import { useState } from 'react';

import ArrowIosDown from '@crehana/compass.icons.outline/ArrowIosDown';
import { cn } from '@crehana/compass.ui/v2';

type ToggleItemProps = {
  title: string;
  className?: string;
  indexChildren?: number;
};

const ToggleItem: React.FC<React.PropsWithChildren<ToggleItemProps>> = ({
  title,
  children,
  className,
  indexChildren,
}) => {
  const [isOpen, setIsOpen] = useState(indexChildren === 0);

  return (
    <li
      tabIndex={indexChildren}
      className={cn(
        'tw-bg-neutral-light-200 tw-rounded-1 tw-overflow-hidden tw-transition-[height] tw-transition-colors',
        // Padding
        'tw-px-2 sm:tw-px-2.4 tw-py-1.6 sm:tw-py-2',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
        className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full"
        aria-expanded={isOpen}
      >
        <h3 className="tw-font-subtitle5 sm:tw-font-subtitle4 tw-text-left tw-mr-1.2 tw-flex-grow">
          {title}
        </h3>

        <ArrowIosDown
          size={24}
          className={cn(
            'tw-fill-current tw-min-w-2.4 tw-w-2.4 tw-h-2.4 tw-will-change-transform tw-transition-transform tw-duration-300 tw-flex-none',
            isOpen && 'tw-transform tw-rotate-180',
          )}
        />
      </button>

      <div
        className={cn(
          'tw-duration-500',
          isOpen ? 'tw-h-auto tw-opacity-100 tw-mt-2' : 'tw-h-0 tw-opacity-0',
        )}
      >
        {children}
      </div>
    </li>
  );
};

export default ToggleItem;
